/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useState } from "react";
import { RichTextComponent } from "cms/components/rich-text/rich-text";

import { SimpliCitySDK } from "cms/sdk";
import { useAuth } from "cms/auth/hooks/useAuth";
import { isStringNotEmpty } from "cms/utils/empty-exists";
import NewsletterImg from "cms/assets/images/newsletter-simplicity.png"; 

const NewsletterCtaComponent = (props) => {
    const { component } = props;
    const { token } = useAuth();

    const heading = component?.heading;
    const subheading = component?.subheading;
    const description = component?.description;
    const subscribe_label = component?.subscribe_label || "Subscribe";
    const email_service_provider = component?.email_service_provider;
    const selected_fields = component?.selected_fields || [];
    const email_group = component?.email_group || null;

    const [formData, setFormData] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitStatus, setSubmitStatus] = useState(null);

    const hasContent =
        isStringNotEmpty(heading) || isStringNotEmpty(subheading) || description || email_service_provider;

    const enabledFields = selected_fields.filter((field) => (typeof field === "object" ? field.enabled : true));

    const handleInputChange = (fieldName) => (event) => {
        setFormData((prev) => ({
            ...prev,
            [fieldName]: event.target.value,
        }));
    };

    const handleSubmit = async () => {
        console.log("email_service_provider::", email_service_provider);
        if (!email_service_provider) {
            return;
        }

        // Validate email if it exists in form data
        if (formData.email && !validateEmail(formData.email)) {
            console.log("Invalid email::", formData.email);
            return;
        }

        setIsSubmitting(true);
        setSubmitStatus(null);

        try {
            await SimpliCitySDK.email.createSubscriber(token, {
                providerKey: email_service_provider,
                firstName: formData.name,
                email: formData.email,
                city: formData.city,
                company: formData.company,
                country: formData.country,
                lastName: formData.lastName,
                phone: formData.phone,
                state: formData.state,
                z_i_p: formData.z_i_p,
                groups: email_group ? [email_group] : [],
            });

            setSubmitStatus("success");
            setFormData({});
        } catch (error) {
            console.error("Newsletter subscription error:", error);
            setSubmitStatus("error");
        } finally {
            setIsSubmitting(false);
        }
    };

    const formatFieldLabel = (fieldName) => {
        if (fieldName === "name") {
            return "First name";
        }
        return fieldName.charAt(0).toUpperCase() + fieldName.slice(1).replace(/_/g, " ");
    };

    const isFieldRequired = (fieldName) => {
        return ["email", "name"].includes(fieldName);
    };

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };
    console.log("description::", description);
    return (
        <>
            {hasContent && (
                <div className="newsletter-cta-component-display">
                    <div className="newsletter-cta-component-display-content">
                        {heading && <h3 className="newsletter-cta-heading">{heading}</h3>}

                        {subheading && <h4 className="newsletter-cta-subheading">{subheading}</h4>}

                        {description && (
                            <div className="newsletter-cta-description">
                                <RichTextComponent component={{ richtext: description }} />
                            </div>
                        )}

                        {submitStatus === "success" ? (
                            <div className="newsletter-cta-form">
                                <div className="newsletter-thank-you">Thank you!</div>
                            </div>
                        ) : (
                            <div className="newsletter-cta-form">
                                {enabledFields.length > 0 && (
                                    <div className="newsletter-form-fields">
                                        {enabledFields.map((field) => {
                                            const fieldName = typeof field === "object" ? field.name : field;
                                            const isRequired = isFieldRequired(fieldName);

                                            return (
                                                <input
                                                    key={fieldName}
                                                    className="newsletter-input-field"
                                                    placeholder={formatFieldLabel(fieldName)}
                                                    value={formData[fieldName] || ""}
                                                    onChange={handleInputChange(fieldName)}
                                                    required={isRequired}
                                                    type={fieldName === "email" ? "email" : "text"}
                                                    style={{ marginRight: "8px" }}
                                                />
                                            );
                                        })}
                                        <button
                                            onClick={handleSubmit}
                                            disabled={isSubmitting || !email_service_provider}
                                            className="newsletter-subscribe-button"
                                            type="button"
                                        >
                                            {subscribe_label}
                                        </button>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                    <div className="newsletter-cta-component-display-image">
                        <img src={NewsletterImg} alt="newsletter"/>
                    </div>
                </div>
            )}
        </>
    );
};

NewsletterCtaComponent.displayName = "NewsletterCtaComponent";
export { NewsletterCtaComponent };
